import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSeconds',
})
export class MinuteSecondsPipe implements PipeTransform {
  transform(time: any, isUTC = false): any {
    if (time == null) {
      return 'null';
    }
    if (isUTC) {
      time = this.calculateTimeOffset(time);
    }
    const timeVal = ('0000' + time.toString()).slice(-4);
    time =
      timeVal.charAt(0) +
      timeVal.charAt(1) +
      ':' +
      timeVal.charAt(2) +
      timeVal.charAt(3);
    let hour = time.split(':')[0];
    let min = time.split(':')[1];
    const part = +hour >= 12 ? 'PM' : 'AM';
    min = (min + '').length === 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + '').length === 1 ? `0${hour}` : hour;
    return `${hour}:${min} ${part}`;
  }


  calculateTimeOffset(time: any): any {
    const timeoffset = new Date().getTimezoneOffset() * -1;
    const timeVal = ('0000' + time.toString()).slice(-4);
    const addedMinutes = timeoffset % 60;
    const addedHours = Math.floor(timeoffset / 60);
    let hour = Number.parseInt(timeVal.charAt(0) + timeVal.charAt(1)) + addedHours;
    let min = Number.parseInt(timeVal.charAt(2) + timeVal.charAt(3)) + addedMinutes;
    if (min > 60) {
      hour += 1;
      min -= 60;
    }
    if (hour > 24) {
      hour -= 24;
    }
    const newHour = ('00' + hour).slice(-2);
    const newMin = ('00' + min).slice(-2);
    return `${newHour}${newMin}`;
  }
}
export function ConvertTimeNumberToString(time: any, isUTC: boolean) {
  if (time == null) {
    return 'null';
  }
  const timeVal = ('0000' + time.toString()).slice(-4);
  if (isUTC) {
    const timeoffset = new Date().getTimezoneOffset() * -1;
    const addedMinutes = timeoffset % 60;
    const addedHours = Math.floor(timeoffset / 60);
    let hour = Number.parseInt(timeVal.charAt(0) + timeVal.charAt(1)) + addedHours;
    let min = Number.parseInt(timeVal.charAt(2) + timeVal.charAt(3)) + addedMinutes;
    if (min > 60) {
      hour += 1;
      min -= 60;
    }
    if (hour > 24) {
      hour -= 24;
    }
    time = `${hour}${min}`;
  }
  time =
    timeVal.charAt(0) +
    timeVal.charAt(1) +
    ':' +
    timeVal.charAt(2) +
    timeVal.charAt(3);
  let hour = time.split(':')[0];
  let min = time.split(':')[1];
  const part = hour > 12 ? 'PM' : 'AM';
  min = (min + '').length === 1 ? `0${min}` : min;
  hour = hour > 12 ? hour - 12 : hour;
  hour = (hour + '').length === 1 ? `0${hour}` : hour;
  return `${hour}:${min} ${part}`;
}
